import { useEffect, useState } from "react";
import constants from "../constants";
import { getStorage } from "utils";
import {
  getOfficeNavigationContext,
  isInOfficeNavigationContext,
  OFFICE_NAV_CONTEXT_CHANGE_EVENT,
} from "utils/officeNavigationContext";
export default function useAgendaFilter() {
  //Office Filter for YourScheduler-Agenda
  let cachedOfficeFilter =
    sessionStorage.getItem(constants.localStorageKeys.agenda.officeFilter) ||
    null;
  cachedOfficeFilter = cachedOfficeFilter ? JSON.parse(cachedOfficeFilter) : [];

  const [selectedOfficeFilter, setOfficeFilter] = useState(cachedOfficeFilter);
  const [apiOffices, setApiOffices] = useState(cachedOfficeFilter);
  const [appliedOfficeFilter, setAppliedOfficeFilter] = useState(cachedOfficeFilter);

  const resetFilters = () => {
    setOfficeFilter([]);
    setApiOffices([]);
    setAppliedOfficeFilter([]);
  };

  useEffect(() => {
    sessionStorage.setItem(
      constants.localStorageKeys.agenda.officeFilter,
      JSON.stringify(apiOffices)
    );
  }, [apiOffices]);

  useEffect(() => {
    const officeContext = getOfficeNavigationContext();
    if (isInOfficeNavigationContext(officeContext) && officeContext?.officeId) {
      setOfficeFilter([officeContext.officeId]);
      setAppliedOfficeFilter([officeContext.officeId]);
    }
  }, []);

  useEffect(() => {
    const syncOfficeFiltersFromContext = () => {
      const officeContext = getOfficeNavigationContext();
      if (isInOfficeNavigationContext(officeContext) && officeContext?.officeId) {
        setOfficeFilter([officeContext.officeId]);
        setAppliedOfficeFilter([officeContext.officeId]);
        return;
      }
      const cachedOfficeFilter =
        sessionStorage.getItem(constants.localStorageKeys.agenda.officeFilter) ||
        null;
      const parsed = cachedOfficeFilter ? JSON.parse(cachedOfficeFilter) : [];
      setOfficeFilter(parsed);
      setAppliedOfficeFilter(parsed);
      setApiOffices(parsed);
    };
    window.addEventListener(
      OFFICE_NAV_CONTEXT_CHANGE_EVENT,
      syncOfficeFiltersFromContext,
    );
    return () =>
      window.removeEventListener(
        OFFICE_NAV_CONTEXT_CHANGE_EVENT,
        syncOfficeFiltersFromContext,
      );
  }, []);

  return {
    selectedOfficeFilter,
    setOfficeFilter,
    apiOffices,
    setApiOffices,
    resetFilters,
    appliedOfficeFilter,
    setAppliedOfficeFilter
  };
}
